import { useState } from 'react';

import AdminDashboard from '../custom/AdminDashboard'
export default function HomePage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="HomePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <AdminDashboard/>
                    </div>
                </div>
            </div>
        </div>
    </section>
		</main>
	);
}
